import {observer} from "mobx-react-lite";
import {stores} from "../../stores";
import {GLOBAL_MEMORY} from "../../stores/memoryStore";
import {ParameterType} from "../../model";
import {getGlobalParameterStateStyle, getPresetParameterStateStyle} from "../../utils/styling";
import {InputRadioLabel} from "./InputRadioLabel";

interface ParameterProps {
    parameter: ParameterType;
    presetNumber?: number;
}

export const InputRadio = observer(({parameter, presetNumber = GLOBAL_MEMORY}: ParameterProps) => {

    // console.log("ConfigurationParamInputCheckboxes:", h(stores.model.config[param.offset]));

    function handleChange(value: number) {
        stores.memory.setValue(parameter, value, presetNumber);
        stores.midi.save(presetNumber);
    }

    function isChecked(value: number) {
        return value === stores.memory.getValue(parameter, presetNumber);
    }

    const style = parameter.type === "global" ?
        getGlobalParameterStateStyle(parameter.id) :
        getPresetParameterStateStyle(parameter.id, presetNumber);

    // console.log("InputRadio render", presetNumber, parameter.id, stores.memory.getValue(parameter, presetNumber));

    return (
        <div className={`param-input input-radio state ${style}`}>
            {parameter.values.map((kv: any, i: number) => {
                const entry = Object.entries(kv);
                // @ts-ignore
                const value: number = parseInt(entry[0][0], 10);
                if (isNaN(value)) {
                    console.error("invalid configuration value for radio", parameter, entry)
                    return null;
                } else {
                    // @ts-ignore
                    const label: string = entry[0][1];
                    return (
                        <label key={i}>
                            <input type="radio" name={`config.${parameter.offset}`}
                                   value={value} checked={isChecked(value)} onChange={() => handleChange(value)} /><InputRadioLabel label={label} />
                        </label>
                    )
                }
            })}
        </div>
    );

});